import { render, staticRenderFns } from "./smsLog.vue?vue&type=template&id=b95dc2c2"
import script from "./smsLog.vue?vue&type=script&lang=ts"
export * from "./smsLog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports